module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAJdJREFUOI3tk8sRgCAMBXccC7AEO5FWrIQarMBSsBPtJB4UjSgj4njzXRJg8/hMgA9lcrhC5RYQoEk0soBb48HdJRqEdRKeKEeDT94abfqNnhlVLC0gnPvDqBhjNkBUgW/OXhVJhBFt1ANjYO6LjRrHGMp1ogbaABqACdV0QHfB6PXLLyKc3+mOAfY7uxiQyBx2vlMKk6cZrLwwZOo+BbwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliJiaoxue.png
// module id = kCUn
// module chunks = 1